import useApplyEventId from '../../hooks/useApplyEventId';
import { useEffect } from 'react';
import { useEventInfo } from '@/features/apply-event/hooks/useEvent';
import { formatDateString, isDateInRange } from '@/utils/dateUtils';
import useAlert from '@/hooks/useAlert';

const EventEndedPopup = () => {
  const eventId = useApplyEventId();
  const { startTime, endTime } = useEventInfo(eventId);

  const alert = useAlert();

  useEffect(() => {
    if (isDateInRange(startTime, endTime)) return;

    alert({
      title: '이벤트가 종료되었어요',
      description: `응모 기간\n${formatDateString(startTime)} ~ ${formatDateString(endTime)}`,
    });
  }, [startTime, endTime, alert]);

  return null;
};

export default EventEndedPopup;
